export default __webpack_public_path__ + "static/media/EmailInvitation.f4d2e070.png";